// @flow
import * as React from 'react';
import clsx from "clsx";
import {DOC_TYPE} from "search2/filter/SearchFilter";
import {roleutil} from "util/roleutil";

type Props = {
  docTypeOpen: boolean;
  handleClick;
  getTranslation;
  loginInfo;
};
export const UlDocType = ({docTypeOpen, handleClick, getTranslation, loginInfo}: Props) => {
  return (
    <ul className={clsx("select-list", "doctype-kind-list")}
      style={{display: docTypeOpen ? 'block' : 'none'}}>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.DEFAULT)}>{getTranslation("I18N_SEARCH_FILTER_ALL")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.APPLICATION_NOTE)}>{getTranslation("I18N_TAB_APPLICATION_NOTE")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.TECHNICAL_GUIDE)}>{getTranslation("I18N_TAB_TECHNICAL_GUIDE")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.SAMPLE)}>{getTranslation("I18N_TAB_SAMPLE")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.TECH_GENERAL)}>{getTranslation("I18N_TAB_TECH_GENERAL")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.MANUAL)}>{getTranslation("I18N_TAB_MANUAL")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.CATALOG)}>{getTranslation("I18N_TAB_CATALOG")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.EDUCATION_VIDEO)}>{getTranslation("I18N_TAB_EDUCATION_VIDEO")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.EDUCATION_INTERNAL)}>{getTranslation("I18N_TAB_EDUCATION_INTERNAL")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.EDUCATION_NOTE)}>{getTranslation("I18N_TAB_EDUCATION_NOTE")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.QNA)}>{getTranslation("I18N_TAB_QNA")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.SOARWARE)}>{getTranslation("I18N_TAB_SOFTWARE")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.OS)}>{getTranslation("I18N_TAB_OS")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.CAD_DATA)}>{getTranslation("I18N_TAB_CAD_DATA")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.CERTIFICATION)}>{getTranslation("I18N_TAB_CERTIFICATION")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.DATASHEET)}>{getTranslation("I18N_TAB_DATASHEET")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.SW_SERVICE)}>{getTranslation("I18N_TAB_SW_SERVICE")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.TROUBLE_SHOOTING)}>{getTranslation("I18N_TAB_TROUBLE_SHOOTING")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.TIP)}>{getTranslation("I18N_TAB_TIP")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.DOC_EVT)}>{getTranslation("I18N_TAB_EVENT")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.DOC_NOTI)}>{getTranslation("I18N_TAB_NOTICE")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.JOB_OFFER)}>{getTranslation("I18N_TAB_JOB_OFFER")}
      </li>
      <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.JOB_SEARCH)}>{getTranslation("I18N_TAB_JOB_SEARCH")}
      </li>
      {roleutil.hasRole('RND', loginInfo.userRoles) && <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.RND_NOTI)}>{getTranslation("I18N_TAB_RND_NOTI")}
      </li>}
      {roleutil.hasRole('RND', loginInfo.userRoles) && <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.RND_QNA)}>{getTranslation("I18N_TAB_RND_QNA")}
      </li>}
      {roleutil.hasRole('RND', loginInfo.userRoles) && <li
        onClick={(e) => handleClick(e, 'doctype-click', DOC_TYPE.RND_TALK)}>{getTranslation("I18N_TAB_RND_TALK")}
      </li>}

    </ul>
  );
};